import { resetIcon } from '../../../bento/dashboard';

export default () => ({
  clearAllButtonRoot: {
    margin: 'auto',
  },
  customButton: {
    borderRadius: '9px',
    maxWidth: '30px',
    maxHeight: '30px',
    minWidth: '30px',
    minHeight: '30px',
    marginTop: '0px',
    fontSize: 9,
    textTransform: 'none',
    color: '#3d4241',
    marginLeft: '0px',
    border: '1px solid #ADADAD',
    '& .clear-icon': {
      minWidth: '11.5px',
      width: '11.5px',
      height: '11.5px',
      backgroundColor: "#60797B",
      mask: `url('${resetIcon.src}') no-repeat center`,
      "-webkit-mask": `url('${resetIcon.src}') no-repeat center`,
      "-webkit-mask-size": 'contain',
    },
    '&:hover': {
      backgroundColor: '#60797B',
      color: 'white',
      "& .clear-icon": {
        backgroundColor: '#FFFFFF',
      },
    },
    '&:disabled': {
      border: '1px solid #ADADAD',

      '& .clear-icon': {
        opacity: 1,
        backgroundColor: '#AEBDBE',
      },
    },
  },
  floatRight: {
    margin: '7px 0px 7px 6px',
  },
  resetText: {
    marginTop: '0px',
    marginLeft: '8px',
    color: '#60797B',
    fontSize: 14,
  },
  resetTextDisabled: {
    marginTop: '0px',
    marginLeft: '8px',
    color: '#AEBDBE',
    fontSize: 14,
  },
  cases: {
    height: '5px',
  },
  Cases: {
    height: '5px',
    margin: '0px',
    backgroundColor: '#0d8461',
  },
  Samples: {
    height: '5px',
    margin: '0px',
    backgroundColor: '#10beff',
  },
  Files: {
    height: '5px',
    margin: '0px',
    backgroundColor: '#e636e4',
  },
  sectionSummaryText: {
    fontSize: '14px',
    flexShrink: '0',
    fontFamily: 'Open Sans',
    fontWeight: '600',
    lineHeight: '1',
    marginLeft: '5px',
    letterSpacing: '0',
    textTransform: 'uppercase',
    overflowWrap: 'break-word',
  },
  dropDownIconSubSection: {
    marginLeft: '0px',
    fill: '#000000',
  },
  customExpansionPanelSummaryRoot: {
    flexDirection: 'row-reverse',
    paddingLeft: 4,
  },
  sectionSummaryTextContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    zIndex: 2,
    fontFamily: 'Open Sans, Lato',
    fontSize: 20,
    fontWeight: 300,
    marginLeft: 3,
    color: '#000000',
  },
  CasesCheckbox: {
    color: '#10A075',
  },
  CasesCheckedIcon: {
    color: '#10A075',
  },
  checkboxRoot: {
    marginLeft: '5px',
    height: 12,
  },
  panelDetailText: {
    color: '#323232',
    fontFamily: 'Nunito',
    fontSize: '14px',
    fontWeight: '200',
  },
  panelSubjectText: {
    color: '#323232',
    fontFamily: 'Nunito',
    fontSize: '14px',
    marginRight: '0px',
  },
  activeFacetDemographics: {
    color: '#0E6292',
  },
  activeFacetStudy: {
    color: '#942A90',
  },
  activeFacetData_Access: {
    color: '#A35719',
  },
  activeFacetSamples: {
    color: '#0E6292',
  },
  activeFacetGenomic: {
    color: '#942A90',
  },
  activeFacetImaging: {
    color: '#A35719',
  },
  activeFacetDiagnosis: {
    color: '#0E6292',
  },
  activeFacetFiles: {
    color: '#942A90',
  },
  activeFacetProteomic: {
    color: '#A35719',
  },
  activeFacetCancer_Nanotechnology: {
    color: '#0E6292',
  },
  searchContainer: {
    margin: '0 2px',
    marginRight: 6,
    width: '100%',
  },
  searchLabel: {
    fontFamily: 'Open Sans',
  },
  findCaseButton: {
    //marginLeft: '105px',
    backgroundColor: '#0B4E75',
    boxSizing: 'border-box',
    height: 30,
    width: 40,
    //border: '1.25px solid #C3E8F7',
    cursor: 'pointer',
    borderRadius: 11,
    display: 'flex',
    marginRight: 6,
    justifyContent: 'center',
    alignItems: 'center',
  },
  findCaseIcon: {
    width: 17,
    height: 17,
  },
  uploadButton: {
    boxSizing: 'border-box',
    fontWeight: '400',
    //height: 32,
    width: '100%',
    display: 'flex',
    justifyContent: 'space-between',
    backgroundColor: '#0B4E75',
    color: '#fff',
    border: '1px solid #C3E8F7',
    borderRadius: 10,
    fontFamily: 'Lato',
    fontSize: 11.5,
    boxShadow: 'none',
    paddingLeft: 10,
    paddingRight: 12,
    '&:hover': {
      backgroundColor: '#0B4E75',
    },
    //fields added to remove button
    visibility: 'hidden',
    height: 0,
    padding: 0,
  },
  iconSpan: {
    marginTop: '5.2px',
  },
  uploadIcon: {
    height: 19,
    width: 19,
  },
  customListPadding: {
    paddingTop: 8,
  },
  customDivider: {
    backgroundColor: '#B1B1B1',
    height: '2px',
    marginLeft: 0,
    marginRight: 0,
    marginBottom: 6,
  },
  paper: {
    border: '1.25px solid #29ABE2',
    backgroundColor: '#717171',
    color: '#fff',
    borderRadius: 10,
    fontFamily: 'Lato',
    fontSize: 12,
    fontWeight: 500,
    boxShadow: '0 0 0 2px rgba(41, 171, 226,0.36)',
    '& ::-webkit-scrollbar': {
      width: '0.6em',
      height: '1em',
    },
    '& ::-webkit-scrollbar-track': {
      '-webkit-box-shadow': 'none',
      borderRadius: '0px',
      backgroundColor: 'transparent',
    },
    '& ::-webkit-scrollbar-thumb': {
      backgroundColor: '#000',
      borderRadius: '0px',
    },
  },
  listbox: {
    height: 223,
    paddingTop: '0px',
    '& li': {
      borderBottom: '1px solid #fff',
      '&:nth-last-child(1)': {
        borderBottom: 'none'
      }
    },
    '& :hover': {
      color: 'white',
      backgroundColor: '#29ABE2;'
    }
  },
  searchResultDetailText: {
    color: '#5E3F14',
    lineHeight: '20px',
    fontFamily: 'Open Sans',
    fontSize: '11px',
  },
  inputRoot: {
    borderRadius: 10,
    height: 32,
    color: '#555555',
    fontFamily: 'Lato',
    fontSize: 11,
    paddingLeft: 12,
    paddingRight: 35,
    backgroundColor: '#fff',
    '& input': {
      height: '7px',
      fontSize: 10,
      paddingLeft: '12px !important',
      fontFamily: 'Nunito',
    },
    '& fieldset': {
      borderWidth: '2px !important',
      borderColor: '#29ABE2 !important',
    },
  },
});


export const uploadModalStyles = {
  paper: {
    minWidth: '32%',
    borderRadius: '10px',
    border: '0px solid #000',
    boxShadow: '0px 3px 5px -1px rgba(0,0,0,0.2), 0px 5px 8px 0px rgba(0,0,0,0.14), 0px 1px 14px 0px rgba(0,0,0,0.12)',
    backgroundColor: '#fff',
  },
  modalTitle: {
    fontFamily: 'Inter',
    borderBottom: '1px solid rgba(#000,0.3)',
    fontSize: 20,
    lineHeight: '24.2px',
    color: '#000000',
    padding: '16px 32px 12px 32px',
    margin: '0px',
    borderTopLeftRadius: 10,
    borderTopRightRadius: 10,
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    fontWeight: '400',
    backgroundColor: '#FFFFFF',
  },
  modalContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    paddingRight: 33,
    paddingLeft: 33,
    backgroundColor: '#CEDFE8',
  },
  helpIcon: {
    zIndex: '600',
    color: '#09486D',
    width: '15px',
    height: '15px',
  },
  orTitle: {
    position: 'fixed',
    color: '#09486D',
    fontSize: 17,
    border: '1px solid #fff',
    lineHeight: '24px',
    fontWeight: '700',
    borderRadius: '50%',
    padding: '7px 8px 9px 8px',
    width: 42,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    marginLeft: -36,
    backgroundColor: '#CEDFE8',
    fontFamily: 'Lato',
    marginTop: 5,
  },
  listTitle: {
    fontWeight: 300,
    fontFamily: 'Nunito Sans',
    color: 'black',
    fontSize: 17,
  },
  textArea: {
    overflowY: 'auto !important',
    height: '151px !important',
    width: '100%',
    border: '1px solid #09486D',
    borderRadius: 10,
    fontSize: 16,
    fontFamily: 'Open Sans',
    color: '#000000',
    padding: '9px 13px',
    '&::placeholder': {
      fontSize: 11,
      fontFamily: 'Open Sans',
      color: '#4579A0',
    },
  },
  uploaderComponent: {
    height: '38px',
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
    marginBottom: '22px',
  },
  uploadInput: {
    opacity: 0,
    zIndex: 4,
    width: '162px',
    height: '43px',
    position: 'absolute',
    borderRadius: '5px',
    cursor: 'pointer',
  },
  uploadButton: {
    width: 162,
    borderRadius: '10px',
    boxSizing: 'border-box',
    boxShadow: 'none',
    backgroundColor: '#09486D',
    height: 43,
    border: '0px',
    fontFamily: 'Raleway',
    fontSize: 12,
    fontWeight: '600',
    lineHeight: '37px',
    marginBottom: '12px',
    textAlign: 'center',
    color: '#fff',
    position: 'absolute',
    padding: '1px 18px 1px 18px ',
  },
  filesection: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    paddingTop: '16px',
    marginTop: '20px',
    marginBottom: '16px',
  },
  fileName: {
    margin: 'unset',
    color: '#09486D',
    fontFamily: 'Open Sans',
    fontSize: 16,
    fontWeight: '600',
    lineHeight: '15px',
  },
  horizontal: {
    height: 1,
    width: 214,
    backgroundColor: '#FFFFFF',
    marginTop: 10,
  },
  summaryContainer: {
    backgroundColor: '#CEDFE8',
    paddingLeft: 33,
    paddingRight: 33,
  },
  arrowRight: {
    color: '#09486D',
    fontSize: '2.5rem',
  },
  summary: {
    color: '#09486D',
    fontSize: 15,
    textAlign: 'center',
    margin: 0,
    paddingTop: 10,
    fontFamily: 'Open Sans',
    fontStyle: 'normal',
    fontWeight: '600',
    lineHeight: '15px',
  },
  btnContainer: {
    display: 'flex',
    marginBottom: 0,
  },
  matched: {
    width: 125,
  },
  unmatched: {
    width: 143,
  },
  summaryButton: {
    fontSize: 15,
    fontWeight: 500,
    lineHeight: '22px',
    color: '#0B4E75',
    backgroundColor: '#fff',
    borderBottom: '4px solid #09486D',
    cursor: 'pointer',
    padding: '3px 12px 10px 12px',
    fontFamily: 'Lato',
    textTransform: 'capitalize',
    height: 32,
    textAlign: 'center',
  },
  unselectedButton: {
    fontSize: 15,
    fontWeight: 500,
    lineHeight: '22px',
    color: '#fff',
    backgroundColor: '#9CBAC9',
    cursor: 'pointer',
    padding: '3px 12px 10px 12px',
    fontFamily: 'Lato',
    textTransform: 'capitalize',
    height: 28,
    textAlign: 'center',
  },
  tableContainer: {
    border: '0px',
    width: '-webkit-fill-available',
    backgroundColor: 'white',
    padding: '6px 14px 14px 14px',
    marginBottom: 16,
  },
  header: {
    fontSize: 11,
    lineHeight: '22px',
    color: '#000',
    textAlign: 'center',
    fontFamily: 'Nunito Sans',
    paddingBottom: 0,
    fontWeight: 400,
    letterSpacing: 0.01,
    textTransform: 'uppercase',
  },
  heading: {
    fontSize: 11,
    lineHeight: '22px',
    color: '#000',
    textAlign: 'center',
    fontFamily: 'Nunito Sans',
    paddingBottom: 0,
    fontWeight: 400,
    letterSpacing: 0.01,
    textTransform: 'uppercase',
  },
  columnPadding: {
    padding: '0px',
  },
  dividerContainer: {
    padding: '0px',
  },
  divider: {
    backgroundColor: '#64C4ED',
    width: '100%',
    height: 1,
  },
  tableColumn: {
    color: '#09486D',
    fontFamily: 'Open Sans',
    fontSize: 13,
    fontWeight: 600,
    lineHeight: '22px',
    textAlign: 'center',
    verticalAlign: 'middle',
  },
  programHeading: {
    color: '#006BA1',
    fontFamily: 'Open Sans',
    fontSize: 13,
    fontWeight: 600,
    lineHeight: '22px',
    textAlign: 'center',
  },
  submitBtn: {
    backgroundColor: '#0B7562',
  },
  clearBtn: {
    backgroundColor: '#09486D',
  },
  cancelBtn: {
    backgroundColor: '#646464',
  },
  button: {
    marginLeft: '5px',
    marginRight: '5px',
    borderRadius: '10px',
    boxSizing: 'border-box',
    height: 43,
    width: 162,
    border: '0px',
    fontSize: 12,
    textAlign: 'center',
    color: '#fff',
    fontFamily: 'Raleway',
    fontWeight: '600',
    lineHeight: '37px',
    boxShadow: 'none',
  },
};